// src/App.jsx
import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./App.css";

/* صفحاتك */
import Home from "./components/page/home";
import ItemsReport from "./components/page/reports/itemsReport";
import AddItems from "./components/page/form/addItems";
import CreateInvoice from "./components/page/form/CreateInvoice";
import Categories from "./components/page/form/Categories";
import InvoicesList from "./components/page/reports/InvoicesList";
import CustomerBrandSheet from "./components/page/reports/CustomerBrandSheet";
import Cashbox from "./components/page/form/Cashbox";
import Login from "./components/page/login";
import PrinterTest from "./printing/PrinterTest";
import UsersAdmin from "./components/page/reports/UsersAdmin";
import CreateUser from "./components/page/form/CreateUser";
import PrintView from "./components/page/PrintView";

function Shell({ children }) {
  return (
    <div className=" bg-gradient-to-b from-light-blue-100 via-light-blue-50 to-light-blue-100">
      <div>{children}</div>
    </div>
  );
}

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const dispatch = useDispatch();

  const checkSession = () => {
    const token = localStorage.getItem("token");
    const tokenExpiration = localStorage.getItem("tokenExpiration");
    if (token && tokenExpiration && Date.now() < Number(tokenExpiration)) {
      setIsLoggedIn(true);
      return;
    }
    setIsLoggedIn(false);
  };

  useEffect(() => {
    checkSession();
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Routes>
        {/* صفحة العرض /brand متاحة للجميع وخارج أي غلاف */}
        <Route path="/brand" element={<CustomerBrandSheet />} />

        {/* غير مسجّل */}
        {!isLoggedIn && (
          <>
            <Route path="/login" element={<Login onLogin={setIsLoggedIn} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}

        {/* مسجّل الدخول – بدون CustomLayout */}
        {isLoggedIn && (
          <>
            <Route
              path="/"
              element={
                <Shell>
                  <Home />
                </Shell>
              }
            />
            <Route
              path="/printer-test"
              element={
                <Shell>
                  <PrinterTest />
                </Shell>
              }
            />
            <Route
              path="/users_admin"
              element={
                <Shell>
                  <UsersAdmin />
                </Shell>
              }
            />
            <Route
              path="/create_user"
              element={
                <Shell>
                  <CreateUser />
                </Shell>
              }
            />

            <Route
              path="/cashbox"
              element={
                <Shell>
                  <Cashbox />
                </Shell>
              }
            />
            <Route path="/print" element={
              <Shell>
                <PrintView />
              </Shell>
            } />

            <Route
              path="/add_category"
              element={
                <Shell>
                  <Categories />
                </Shell>
              }
            />

            <Route
              path="/item_reports"
              element={
                <Shell>
                  <ItemsReport />
                </Shell>
              }
            />
            <Route
              path="/add_invoice"
              element={
                <Shell>
                  <CreateInvoice />
                </Shell>
              }
            />

            <Route
              path="/invoice"
              element={
                <Shell>
                  <InvoicesList />
                </Shell>
              }
            />

            <Route
              path="/add_item"
              element={
                <Shell>
                  <AddItems />
                </Shell>
              }
            />

            {/* أي مسار غير معروف → الرئيسية */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}
